// web/src/lib/errors.ts — the API's error envelope is { error: { message, statusCode } }; httpApi throws its text.
export function apiErrorText(e: unknown, fallback: string): string {
  const raw = e instanceof Error ? e.message : '';
  try { return (JSON.parse(raw) as { error?: { message?: string } }).error?.message || fallback; }
  catch { return raw || fallback; }
}

/** The HTTP status inside a thrown API error, when there is one. */
export function apiErrorStatus(e: unknown): number | null {
  try { return (JSON.parse(e instanceof Error ? e.message : '') as { error?: { statusCode?: number } }).error?.statusCode ?? null; }
  catch { return null; }
}
